"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.C_ACCESS_TOKEN_KEY = exports.DFLAG = void 0;
exports.DFLAG = false;
exports.C_ACCESS_TOKEN_KEY = 'CYBERCONNECT_ACCESS_TOKEN';
//# sourceMappingURL=constant.js.map